import { getProductsById } from "../api";

async function CheckCartQty(items) {
  let success = true;
  for (const item of items) {
    const product = await getProductsById(item.id);
    if (product) {
      const variants = product.variants;
      let selectedVariant;

      // If Varaiants Available in Orginal Product then filter based on color
      if (variants) {
        selectedVariant = variants.find(
          (variant) => variant.color === item.selectedVariant[0].color
        );
      }
      // If Size is available to Variant of Orginal Product
      if (selectedVariant && selectedVariant.size) {
        if (item.selectedVariant[0].size === undefined || null) {
          return {
            success: false,
            message: `Size is not selected for ${product.name}`,
          };
        } else {
          selectedVariant.size.forEach((sizes) => {
            // const itemSize = item.selectedVariant[0].size.find(
            //   (itemSize) => itemSize.name === size.name
            // );
            // if (itemSize) {
            if (sizes.qty <= parseInt(item.qty)) {
              return {
                success: false,
                message: `Quantity not available 1${product.name}`,
              };
              //   }
            }
          });
        }
      } else if (selectedVariant) {
        if (!(selectedVariant.qty >= parseInt(item.qty))) {
          return {
            success: false,
            message: `Variant Qty not available ${product.name}`,
          };
        }
      } else if (!selectedVariant) {
        if (!(product.stock >= parseInt(item.qty))) {
          return {
            success: false,
            message: `Quantity not available ${product.name}`,
          };
        }
      }
    }
  }

  if (!success) {
    return {
      success: false,
      message: `Quantity not available for some Products`,
    };
  }

  return { success: true, message: "" };
}

export default CheckCartQty;
